import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setStoredTokens, clearStoredTokens } from "@/lib/api";

const AuthCtx = createContext(null);

const stripTokens = (data) => {
  const { access_token, refresh_token, ...u } = data || {};
  if (access_token) setStoredTokens(access_token, refresh_token);
  return u;
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me", { timeout: 15000 })
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    const u = stripTokens(data);
    setUser(u);
    return u;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    const u = stripTokens(data);
    setUser(u);
    return u;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    clearStoredTokens();
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
